import { Badge } from "@circleco/compass/components/Badge";

import { t } from "@/i18n-js/instance";

import { getExtensionFromFilename, isImage } from "./attachmentHelpers";
import type { AttachmentItem } from "./types";

interface AttachmentBadgeProps {
  contentType: string;
  filename: string;
  status: AttachmentItem["status"];
}

export const AttachmentBadge = ({
  status,
  contentType,
  filename,
}: AttachmentBadgeProps) => {
  if (status === "error") {
    return (
      <Badge
        variant="secondary"
        label={t("circle_ai_home.attachments.upload_error_tag")}
      />
    );
  }

  if (status === "uploading" || isImage(contentType)) {
    return null;
  }

  const extension = (
    getExtensionFromFilename(filename) || "file"
  ).toUpperCase();
  return <Badge variant="secondary" label={extension} />;
};
